<div class="form-editor mb-3" [ngClass]="{'mb-4': editing && formInputs.get(row.key).invalid, 'mt-3': !editable }">
	<div class="row-table" *ngIf="row">
		<div [hidden]="editing">
			<div class="row align-items-end display-row">
				<div class="col">
					<div class="title pb-1" *ngIf="row.title && row.title !== ''">{{ row.title }}</div>
					<div class="value" [ngClass]="row.displaySize" ngbAutoFocus>
						<span class="material-icons row-icon" [hidden]="!row.icon">{{ row.icon }}</span> {{ getDisplayLabel(row) }}
					</div>
				</div>
				<div class="col-xs-auto edit-button">
					<button
						mat-icon-button
						matSuffix
						[hidden]="editing || !editable"
						(click)="editForm()"
						i18n-title="edit field button"
						title="Edit"
						type="button"
					>
						<mat-icon>edit</mat-icon>
					</button>
				</div>
			</div>
		</div>
		<div [hidden]="!editing">
			<form [formGroup]="formInputs" class="container form-container px-0">
				<mat-form-field appearance="standard" class="width-100 mx-auto form-field">
					<mat-label>{{ row.title }}</mat-label>
					<ng-container [ngSwitch]="row.type">
						<mat-select #focusElement *ngSwitchCase="formEditorInputType.select" class="value {{ row.displaySize }}" [ngClass]="{'placeholder':inputIsEmpty()}" formControlName="{{ row.key }}" >
							<mat-option *ngFor="let option of row.options" [value]="option.value">{{ option.label }}</mat-option>
						</mat-select>
						<input #focusElement matInput *ngSwitchDefault class="value {{ row.displaySize }}" [ngClass]="{'placeholder':inputIsEmpty()}" [placeholder]="row.placeholder || ''" type="{{ row.type }}" formControlName="{{ row.key }}" />
					</ng-container>
					<div matSuffix class="row mx-0">
						<button
							mat-icon-button
							(click)="resetControl(row.key)"
							i18n-title="cancel form input button"
							title="Cancel"
							type="button"
						>
							<mat-icon>cancel</mat-icon>
						</button>
						<button
							mat-icon-button
							[disabled]="!formValidAndChanged()"
							(click)="saveForm()"
							i18n-title="save form input button"
							title="Save"
							type="button"
						>
							<mat-icon>check_circle</mat-icon>
						</button>
					</div>
					<div
						class="password-prompt"
						[ngClass]="{ 'text-success': showPasswordSuccess() }"
						*ngIf="row.key === 'password' && !showPasswordError()"
					>
						<span i18n>minimum 8, a mix of uppercase, lowercase and number characters</span>
					</div>

					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.get(row.key)"
						[type]="row.type"
					></mat-error>
				</mat-form-field>
			</form>
		</div>
	</div>
</div>
